export default "__VITE_ASSET__X1mfbxil__"